// src/documents/xlsx/templateLoader.js
//
// public/templates/ altındaki xlsx şablonlarını fetch ile yükler ve cache'ler.
// Şablonlar sadece bir kez indirilir; cache aynı ArrayBuffer'ı bozmamak için
// her çağrıda kopyasını döndürür.

const cache = new Map();

/**
 * Verilen şablon adını fetch eder ve ArrayBuffer döndürür.
 * @param {string} name - public/templates altındaki dosya adı (uzantısız)
 * @returns {Promise<ArrayBuffer>}
 */
export async function loadXlsxTemplate(name) {
  if (cache.has(name)) {
    // Cache'deki buffer'ı bozmamak için kopya gönder — XLSX.read mutate edebilir.
    return cache.get(name).slice(0);
  }
  const base = process.env.PUBLIC_URL || '';
  const url = `${base}/templates/${name}.xlsx`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`xlsx template indirilemedi: ${url} (${res.status})`);
  }
  const buf = await res.arrayBuffer();
  cache.set(name, buf);
  return buf.slice(0);
}
